import AnimatedPage from '@/components/motion/animated-page';
import BottomTabBar from '@/components/navigation/bottom-tab-bar';
import { ROUTES } from '@/app/routes';
import { useEffect } from 'react';
import { useLocation, useNavigate, useOutlet } from 'react-router';

function isDetailPath(pathname: string): boolean {
	return (
		pathname.startsWith(ROUTES.myClient) ||
		pathname.startsWith(ROUTES.client) ||
		pathname === ROUTES.admin ||
		pathname === ROUTES.adminStats ||
		pathname === ROUTES.adminSettings ||
		pathname === ROUTES.adminUsers ||
		pathname.startsWith(ROUTES.adminUser)
	);
}

function resolveBackPath(pathname: string): string {
	if (pathname.startsWith(ROUTES.myClient)) return ROUTES.myClients;
	if (pathname.startsWith(ROUTES.client)) return ROUTES.clients;
	if (pathname === ROUTES.adminStats || pathname === ROUTES.adminSettings || pathname === ROUTES.adminUsers || pathname.startsWith(ROUTES.adminUser)) {
		return ROUTES.admin;
	}
	if (pathname === ROUTES.admin) return ROUTES.myClients;
	return ROUTES.myClients;
}

export default function AppShell() {
	const navigate = useNavigate();
	const location = useLocation();
	const outlet = useOutlet();

	useEffect(() => {
		const webApp = window.Telegram?.WebApp;
		if (!webApp?.BackButton) return;

		const showBack = isDetailPath(location.pathname);

		if (!showBack) {
			webApp.BackButton.hide();
			return;
		}

		const backPath = resolveBackPath(location.pathname);

		function onBack() {
			navigate(backPath);
		}

		webApp.BackButton.show();
		webApp.BackButton.onClick(onBack);

		return () => {
			webApp.BackButton.offClick(onBack);
			webApp.BackButton.hide();
		};
	}, [location.pathname, navigate]);

	return (
		<div className='relative h-full w-full min-h-0 flex flex-col overflow-hidden'>
			<div
				className='flex-1 basis-0 min-h-0 w-full overflow-hidden flex flex-col'
				style={{ paddingBottom: 'calc(3.5rem + env(safe-area-inset-bottom))' }}
			>
				<div className='flex-1 basis-0 min-h-0 w-full overflow-hidden'>
					<AnimatedPage pathname={location.pathname} locationKey={location.key}>
						{outlet}
					</AnimatedPage>
				</div>
			</div>
			<BottomTabBar />
		</div>
	);
}
